import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Close from '@mui/icons-material/Close';
import { TintedIconButton } from '@/ui';
import type { ActionProps } from 'react-querybuilder';

/**
 * The remove control for every react-querybuilder instance in the app: the same tinted red X
 * circle that heads an offer-action row (see RemoveActionButton), so a rule or group is removed
 * the way any other row is. The library's default is a plain <button> reading "x", which is easy
 * to miss and does not pick up the theme.
 *
 * `title` is the library's translation ("Remove rule" / "Remove group") and names the button;
 * `className` keeps the library's `rule-remove` / `ruleGroup-remove` hooks. A disabled builder
 * (a read-only summary) renders nothing rather than a greyed-out X.
 */
export default function RemoveAction({ title = 'Remove', className, handleOnClick, disabled }: ActionProps) {
  if (disabled) return null;
  return (
    <Tooltip describeChild title={title}>
      <TintedIconButton color='error' type='button' className={className} aria-label={title} onClick={handleOnClick}>
        <Close />
      </TintedIconButton>
    </Tooltip>
  );
}
